import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { KindeAngularService } from 'kinde-angular';
import { take, map } from 'rxjs';

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(KindeAngularService);

  return authService.accessToken$.pipe(
    take(1),
    map((accessToken) => {
      if (!accessToken) {
        sessionStorage.setItem('post_login_url', state.url);
        authService.login();
        return false;
      }
      return true;
    })
  );
};
